import { apiClient } from './client';
import type { WorldList, WorldDetail } from './types/shared';

export const worlds = {
  async list(): Promise<WorldList[]> {
    try {
      const response = await apiClient.get('/worlds/');
      return response.data;
    } catch (error) {
      console.error('Failed to fetch worlds:', error);
      throw error;
    }
  },

  async get(slug: string): Promise<WorldDetail> {
    try {
      const response = await apiClient.get(`/worlds/${slug}/`);
      return response.data;
    } catch (error) {
      console.error(`Failed to fetch world details for ${slug}:`, error);
      throw error;
    }
  }
};
